var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42611 14.6693C4.7442 14.6693 1.75943 11.6845 1.75943 8.00258C1.75943 4.3207 4.7442 1.33594 8.42611 1.33594C12.108 1.33594 15.0928 4.3207 15.0928 8.00258C15.0928 11.6845 12.108 14.6693 8.42611 14.6693ZM8.42611 13.3359C11.3716 13.3359 13.7594 10.9481 13.7594 8.00258C13.7594 5.05708 11.3716 2.66927 8.42611 2.66927C5.48058 2.66927 3.09276 5.05708 3.09276 8.00258C3.09276 10.9481 5.48058 13.3359 8.42611 13.3359ZM6.09276 9.33592H9.75944C9.94351 9.33592 10.0928 9.18672 10.0928 9.00258C10.0928 8.81852 9.94351 8.66925 9.75944 8.66925H7.09278C6.17229 8.66925 5.4261 7.92305 5.4261 7.00258C5.4261 6.08213 6.17229 5.33594 7.09278 5.33594H7.75944V4.0026H9.09278V5.33594H10.7594V6.66925H7.09278C6.90867 6.66925 6.75943 6.81852 6.75943 7.00258C6.75943 7.18672 6.90867 7.33592 7.09278 7.33592H9.75944C10.6799 7.33592 11.4261 8.08212 11.4261 9.00258C11.4261 9.92305 10.6799 10.6693 9.75944 10.6693H9.09278V12.0026H7.75944V10.6693H6.09276V9.33592Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.2dd780e817eda2f713b7a2c16a2eb9ba.svg";
export { ForwardRef as ReactComponent };